var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.073,
    height: 19,
    viewBox: "0 0 19.073 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_202",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 202",
    transform: "translate(-753.733 -967.903)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_234",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 234",
    width: 19,
    height: 19,
    transform: "translate(753.733 967.903)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LIKE",
    transform: "translate(753.811 968.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-heart-empty",
    "data-name": "Icon ionic-md-heart-empty",
    d: "M17.146,4.5a5.618,5.618,0,0,0-4.274,2A5.618,5.618,0,0,0,8.6,4.5,5.164,5.164,0,0,0,3.375,9.756c0,3.63,3.228,6.543,8.119,11.036l1.379,1.242,1.379-1.242c4.89-4.493,8.119-7.406,8.119-11.036A5.164,5.164,0,0,0,17.146,4.5ZM13.457,19.536l-.192.178-.393.356-.393-.356-.192-.178a58.038,58.038,0,0,1-5.6-5.571,6.7,6.7,0,0,1-1.845-4.21A3.8,3.8,0,0,1,5.923,7.048,3.716,3.716,0,0,1,8.6,5.961a4.188,4.188,0,0,1,3.155,1.484l1.119,1.329,1.119-1.329a4.172,4.172,0,0,1,3.155-1.484,3.734,3.734,0,0,1,2.68,1.087,3.806,3.806,0,0,1,1.082,2.708,6.735,6.735,0,0,1-1.845,4.21A58.156,58.156,0,0,1,13.457,19.536Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#242323"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlack);
export default __webpack_public_path__ + "static/media/heart_black.16612d1f73ed0cd44494fc27c81707cc.svg";
export { ForwardRef as ReactComponent };